var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import-modals"},[_c('confirmation-modal',{attrs:{"cancel":_vm.close,"confirm":_vm.deleteRow,"title":"Confirme exclusão do Supervisor","message":"Tem certeza que deseja excluir esse Supervisor?"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }